/**
 * 会計が終わった瞬間に自動印刷を起こす。
 *
 * ## なぜ要るか
 *
 * レシートの自動印刷は 5 秒ごとのポーリングで、しかも 1 tick で 3 系統
 * (QR 単発決済 / 卓会計 / 会計伝票) を順に叩く。**会計直後に走るとは限らない**
 * ので、レジで「現金受領」を押してから紙が出るまで体感で 10〜20 秒かかっていた。
 * 客を待たせる場面なので、この待ちは許容できない。
 *
 * **払われた瞬間を知っているのはレジ画面**なので、そこから起こす。
 *
 * ## ポーリングは残す
 *
 * 客のスマホからの QR 決済や、別の端末で行われた会計は**レジ画面が知らない**。
 * イベントは「知っているときは待たない」ための近道で、取りこぼしの受け皿は
 * 従来どおりポーリング。
 *
 * ## なぜ DOM イベントか
 *
 * 自動印刷は `AutoPrintMount` が店舗レイアウト直下に常駐して回しており、
 * レジ画面とは兄弟関係にある。props も context も通っていないので、既存の
 * `yokoso-qr-scan` (useStore) と同じ document イベントに揃える。
 */
export const PAYMENT_DONE_EVENT = 'yokoso-payment-done'

/** 会計が成立した直後に呼ぶ。自動印刷が動いていなければ何も起きない。 */
export function notifyPaymentDone(): void {
  document.dispatchEvent(new CustomEvent(PAYMENT_DONE_EVENT))
}

/** 購読する。戻り値を呼ぶと解除される (useEffect の cleanup で使う)。 */
export function onPaymentDone(handler: () => void): () => void {
  document.addEventListener(PAYMENT_DONE_EVENT, handler)
  return () => document.removeEventListener(PAYMENT_DONE_EVENT, handler)
}
